"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleProxyMatchToMatchType = exports.matchToAppleProxyMatchType = exports.appleStatusToAppleChannelStatus = exports.appleStatusToAppleChannelRegionStatus = exports.appleStatusToAppleChannelKeywordStatus = exports.appleChannelKeywordStatusToAppleProxyKeywordStatus = exports.appleChannelRegionStatusToAppleProxyStatus = exports.appleChannelStatusToAppleProxyStatus = void 0;
const ruby_1 = require("../ruby");
function appleChannelStatusToAppleProxyStatus(status) {
    return status === ruby_1.AppleChannelStatus.ACTIVE ? "ENABLED" : "PAUSED";
}
exports.appleChannelStatusToAppleProxyStatus = appleChannelStatusToAppleProxyStatus;
function appleChannelRegionStatusToAppleProxyStatus(status) {
    return status === ruby_1.AppleChannelRegionStatus.ACTIVE ? "ENABLED" : "PAUSED";
}
exports.appleChannelRegionStatusToAppleProxyStatus = appleChannelRegionStatusToAppleProxyStatus;
function appleChannelKeywordStatusToAppleProxyKeywordStatus(status) {
    return status === ruby_1.AppleChannelKeywordStatus.ACTIVE ? "ACTIVE" : "PAUSED";
}
exports.appleChannelKeywordStatusToAppleProxyKeywordStatus = appleChannelKeywordStatusToAppleProxyKeywordStatus;
function appleStatusToAppleChannelKeywordStatus(status) {
    switch (status) {
        case "ENABLED":
            return ruby_1.AppleChannelKeywordStatus.ACTIVE;
        case "RUNNING":
            return ruby_1.AppleChannelKeywordStatus.ACTIVE;
        case "ACTIVE":
            return ruby_1.AppleChannelKeywordStatus.ACTIVE;
        case "PAUSED":
            return ruby_1.AppleChannelKeywordStatus.DISABLED;
        case "NOT_RUNNING":
            return ruby_1.AppleChannelKeywordStatus.DISABLED;
        case null:
            return ruby_1.AppleChannelKeywordStatus.DISABLED;
        case undefined:
            return ruby_1.AppleChannelKeywordStatus.DISABLED;
    }
}
exports.appleStatusToAppleChannelKeywordStatus = appleStatusToAppleChannelKeywordStatus;
function appleStatusToAppleChannelRegionStatus(status) {
    switch (status) {
        case "ENABLED":
            return ruby_1.AppleChannelRegionStatus.ACTIVE;
        case "RUNNING":
            return ruby_1.AppleChannelRegionStatus.ACTIVE;
        case "ACTIVE":
            return ruby_1.AppleChannelRegionStatus.ACTIVE;
        case "PAUSED":
            return ruby_1.AppleChannelRegionStatus.DISABLED;
        case "NOT_RUNNING":
            return ruby_1.AppleChannelRegionStatus.DISABLED;
        case null:
            return ruby_1.AppleChannelRegionStatus.DISABLED;
        case undefined:
            return ruby_1.AppleChannelRegionStatus.DISABLED;
    }
}
exports.appleStatusToAppleChannelRegionStatus = appleStatusToAppleChannelRegionStatus;
function appleStatusToAppleChannelStatus(status) {
    switch (status) {
        case "ENABLED":
            return ruby_1.AppleChannelStatus.ACTIVE;
        case "RUNNING":
            return ruby_1.AppleChannelStatus.ACTIVE;
        case "ACTIVE":
            return ruby_1.AppleChannelStatus.ACTIVE;
        case "PAUSED":
            return ruby_1.AppleChannelStatus.DISABLED;
        case "NOT_RUNNING":
            return ruby_1.AppleChannelStatus.DISABLED;
        case null:
            return ruby_1.AppleChannelStatus.DISABLED;
        case undefined:
            return ruby_1.AppleChannelStatus.DISABLED;
    }
}
exports.appleStatusToAppleChannelStatus = appleStatusToAppleChannelStatus;
function matchToAppleProxyMatchType(match) {
    switch (match) {
        default:
            return "EXACT";
        case ruby_1.KeywordMatchType.EXACT:
            return "EXACT";
        case ruby_1.KeywordMatchType.BROAD:
            return "BROAD";
    }
}
exports.matchToAppleProxyMatchType = matchToAppleProxyMatchType;
function appleProxyMatchToMatchType(match) {
    switch (match) {
        case "EXACT":
            return ruby_1.KeywordMatchType.EXACT;
        case "BROAD":
            return ruby_1.KeywordMatchType.BROAD;
    }
}
exports.appleProxyMatchToMatchType = appleProxyMatchToMatchType;
